import BasicLayout from '@/layouts/basic-layout';
var pre = 'market-';
export default {
  path: '/market',
  name: 'market',
  redirect: {
    name: "".concat(pre, "stall")
  },
  meta: {
    auth: ['market-manage'],
    title: '市场管理'
  },
  component: BasicLayout,
  children: [{
    path: 'renewal',
    name: "".concat(pre, "renewal"),
    meta: {
      auth: ['market-manage-renewal'],
      title: '续租审核'
    },
    component: function component() {
      return import('@/pages/market/renewal');
    }
  }, {
    path: 'term-manage',
    name: "".concat(pre, "term-manage"),
    meta: {
      auth: ['market-manage-term'],
      title: '租期管理'
    },
    component: function component() {
      return import('@/pages/market/term-manage');
    }
  }, {
    path: 'approve',
    name: "".concat(pre, "approve"),
    meta: {
      auth: ['market-manage-approve'],
      title: '信息审核'
    },
    component: function component() {
      return import('@/pages/market/approve');
    }
  }, {
    path: 'stall',
    name: "".concat(pre, "stall"),
    meta: {
      auth: ['market-manage-stall'],
      title: '一铺一档'
    },
    component: function component() {
      return import('@/pages/market/stall');
    }
  }, {
    path: 'stall-manage',
    name: "".concat(pre, "stall-manage"),
    meta: {
      auth: true,
      title: '铺面维护',
      tabs: false
    },
    component: function component() {
      return import('@/pages/market/stall/manage');
    }
  }, {
    path: 'sign-up',
    name: "".concat(pre, "sign-up"),
    meta: {
      auth: ['market-manage-sign-up'],
      title: '报名管理'
    },
    component: function component() {
      return import('@/pages/market/sign-up');
    }
  }, {
    path: 'valid',
    name: "".concat(pre, "valid"),
    meta: {
      auth: ['settle-in-valid'],
      title: '入驻校验人员'
    },
    component: function component() {
      return import('@/pages/market/valid');
    }
  }, {
    path: 'paid-bill',
    name: "".concat(pre, "paid-bill"),
    meta: {
      auth: ['paid-bill'],
      title: '支付账单'
    },
    component: function component() {
      return import('@/pages/market/paid-bill');
    }
  }, {
    path: 'repair-order',
    name: "".concat(pre, "repair-order"),
    meta: {
      auth: ['repair-order'],
      title: '物业报修'
    },
    component: function component() {
      return import('@/pages/market/repair-order');
    }
  }, {
    path: 'market-property-inspection',
    name: "".concat(pre, "market-property-inspection"),
    meta: {
      auth: ['market-property-inspection'],
      title: '验房管理'
    },
    component: function component() {
      return import('@/pages/market/market-property-inspection');
    }
  }, {
    path: 'unpaid-bill',
    name: "".concat(pre, "unpaid-bill"),
    meta: {
      auth: ['unpaid-bill'],
      title: '待支付账单'
    },
    component: function component() {
      return import('@/pages/market/unpaid-bill');
    }
  }, {
    path: 'early-warning',
    name: "".concat(pre, "early-warning"),
    meta: {
      auth: ['early-warning'],
      title: '预警管理'
    },
    component: function component() {
      return import('@/pages/market/early-warning');
    }
  }]
};